module.exports = __webpack_public_path__ + "img/微信图片_20200810010801.67d55c0c.jpg";